export const BulkCaseCreateStrings = {
  title: 'Bulk Case Creation',
  cancelBtn: 'Cancel',
  submitBtn: 'Upload',
  text: 'Drop your documents here,',
  action: 'or select',
  additionalInfo: 'Supports Excel files up to 20MB',
};
